import { render } from "./menu-form.vue?vue&type=template&id=441988cc"
import script from "./menu-form.vue?vue&type=script&lang=js"
export * from "./menu-form.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__